export default __webpack_public_path__ + "static/media/pexels-daniel-frank-287237.6651c4c6.jpg";